import React from "react";
import { useNavigate } from "react-router-dom";
import "./AlumniLanding.css";

const AlumniLanding = () => {

  const navigate = useNavigate();

  // Navigate to Alumni Login
  const handleContribute = () => {
    navigate("/alumni-login");
  };



  return (
    <div className="pjc_landing">

      {/* Hero Section */}
      <section className="pjc_hero">
        <div className="pjc_overlay">
          <div className="pjc_container">
            <img
              src="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Pjc+module/pjc+logo+(1).webp"
              alt="ACCET Platinum Jubilee Logo"
              className="pjc_logo"
            />

            <h1 classname="name">ACCET PLATINUM JUBILEE</h1>

            <h2>Celebrating 75 Years of Excellence</h2>

            <p>
              Together, let us express our gratitude to our alma mater by
              helping build a stronger and more vibrant ACCET for future
              generations.
            </p>

            <button
              className="pjc_btn"
              onClick={handleContribute}
            >
              Contribute Now
            </button>

          </div>
        </div>
      </section>

      {/* Message */}
      <section className="pjc_section">

        <div className="pjc_container">

          <div className="pjc_letter">

            <h2 className="pjc-new">DEAR ESTEEMED ALUMNI,</h2>

            <p>
              Greetings from the Platinum Jubilee Committee of
              <strong>
                {" "}Alagappa Chettiar Government College of Engineering &
                Technology (ACCET), Karaikudi.
              </strong>
            </p>

            <p>
              As you are aware, our beloved alma mater is approaching a historic
              milestone—its <strong>75th year of service to the nation.</strong>
              Founded by the visionary philanthropist
              <strong> Dr. Alagappa Chettiar</strong>, ACCET has, for over seven
              decades, transformed thousands of students into accomplished
              engineers, technologists, entrepreneurs, administrators and
              industry leaders.
            </p>

            <p>
              While the institution has consistently produced outstanding
              graduates, the college today faces significant infrastructure
              challenges when compared to many leading engineering institutions.
              Over the years, several facilities and developmental projects have
              been made possible largely through the generous contributions of
              alumni, as government funding alone has been insufficient to meet
              the growing needs of the institution.
            </p>

            <p>
              To commemorate the Platinum Jubilee Year, the Committee has
              embarked on an ambitious mission to raise funds for creating and
              upgrading key infrastructure that will benefit future generations
              of students.
            </p>

            <h3 className="pjc-new">Development Projects</h3>

            <ul className="pjc_projects">
              <li>Establishment of an Incubation Centre to promote innovation, start-ups, research & development activities and Centres of Excellence.</li>

              <li>Construction of a Guest House with accommodation facilities for alumni, parents, guests and visiting faculty.</li>

              <li>Restoration and preservation of the iconic Main Building.</li>

              <li>Air-conditioning and modernization of Murugappa Hall with advanced audio-visual facilities.</li>

              <li>Renovation and upgrading of hostel facilities.</li>

              <li>Improvement of sanitation facilities and other essential campus infrastructure.</li>
            </ul>

            <div className="pjc_target">
              <h3>Fund Raising Target</h3>
              <h1>₹75 Crores</h1>
            </div>

            <p>
              Achieving this vision will require the wholehearted support of
              distinguished alumni such as yourself.
            </p>

            <p>
              We therefore earnestly request you to consider making a generous
              contribution, both personally and through the
              <strong> Corporate Social Responsibility (CSR)</strong> initiatives
              of your organization. Your support will play a vital role in
              strengthening the institution that laid the foundation for our
              professional success.
            </p>

            <p>
              Together, let us express our gratitude to our alma mater by
              helping build a stronger and more vibrant ACCET for future
              generations.
            </p>

            <p>
              We look forward to your valuable support and participation in this
              landmark celebration.
            </p>

            <div className="pjc_signature">

              <h3 className="pjc-new">Thanking You,</h3>

              <p>
                <strong className="pjc-new">Platinum Jubilee Committee</strong><br />
                Alagappa Chettiar Government College of Engineering &
                Technology (ACCET), Karaikudi
              </p>

            </div>

            <div className="pjc_committee">

              <div className="pjc_member">
                <h4 className="pjc-new">Er. PL. Avichi</h4>
                <p>President</p>
                <span>Platinum Jubilee Committee</span>
              </div>


              <div className="pjc_member">
                <h4 className="pjc-new">Er. S.R. Sabapathi</h4>
                <p>Secretary</p>
                <span>Platinum Jubilee Committee</span>
              </div>

              <div className="pjc_member">
                <h4 className="pjc-new">Prof. S. Senthilkumar</h4>
                <p>Secretary</p>
                <span>ACCETOSA</span>
              </div>

              <div className="pjc_member">
                <h4 className="pjc-new">Dr. C. Subramanian</h4>
                <p>Treasurer</p>
                <span>ACCETOSA</span>
              </div>

              

            </div>

            <div className="pjc_button">
              <a
                href="https://drive.google.com/file/d/1-6rXvEtDfaDDkLm_gYJXniQx_vCVBLni/view?usp=drivesdk"
                target="_blank"
                rel="noopener noreferrer"
                className="pjc_btn"
              >
                Read More
              </a>
            </div>

          </div>

        </div>

      </section>

    </div>
  );
};

export default AlumniLanding;